import { isAxiosError } from 'axios';
import { apiClient } from '@/axios';
import { Endpoints } from '@/enums';

interface VerifyRutResponse {
  m_Item1: {
    aptoNro: number;
    aptoNroSpecified: boolean;
    calle: string;
    calleNro: string;
    calleNroSpecified: boolean;
    ciudad: string;
    departamento: string;
    naturalezaFiscal: string;
    nombreFantasia: string;
    razonSocial: string;
    tipoEntidad: number;
    tipoEntidadSpecified: boolean;
  };
  m_Item2: string;
}

type QueryType = {
  rut: string | null;
};
interface ApiResponse<T> {
  value: T;
}

export const verifyRut = async (
  query: QueryType
): Promise<VerifyRutResponse> => {
  try {
    const res = await apiClient.post<ApiResponse<VerifyRutResponse>>(
      Endpoints.VerifyRut,
      query
    );
    return res.data.value;
  } catch (error) {
    if (isAxiosError(error) && error.response) {
      if (error.response.status === 404) {
        throw new Error('Invalid Data');
      } else {
        throw new Error(error.message);
      }
    } else {
      throw error;
    }
  }
};
